<template>
  <div class="col p-0">
    <ColorPointsHeader :message="greenHeaderMessage" color="rgba(190, 206, 35, 0.5)" />
    <div class="paragraphe1">
      <div class="row center paragraphe1">
        <div class="col-6 d-flex align-items-center">
          <div class="text-center" v-html=" focus.paragraphe1 ? focus.paragraphe1.texte : '' "></div>
        </div>
        <div class="col-6">
          <img src="../../assets/images/ingenierieEtConseilPatrimoniaux_p1_img1.png" class="img-fluid lozad"/>
        </div>
      </div>
    </div>
    <div class="paragraphe2 row center d-flex">
      <div class="col-2 d-flex justify-content-end">
        <img src="../../assets/images/effet_points_colonne_1.png"/>
      </div>
      <div class="col-8 d-flex align-items-center flex-column">
        <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-5"></div>
        <h2 class="justify-content-center font-weight-bold" v-html=" focus.paragraphe2 ? focus.paragraphe2.titre : '' "></h2>
        <div class="bulleGrid container d-flex flex-wrap">
          <div class="bulle p-3 d-flex align-items-center flex-column" v-for="(bulle, key) in bulles" :key="key">
              <img :src="focus[bulle].image" alt="image" width="52px" height="55px" class="m-1"/>
              <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
              <div class="text-center" v-html="focus[bulle].titre"></div>
          </div>
        </div>
      </div>
      <div class="col-2 d-flex justify-content-start">
        <img src="../../assets/images/effet-points-colonne-2.png"/>
      </div>
    </div>
    <div class="paragraphe3 bg-grey p-5 mt-2 d-flex align-items-center flex-column">
        <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
        <h1>Quelle est votre situation ?</h1>
        <router-link class="text-uppercase text-dark" :to="{ name: 'EtudePatrimonialeForm' }">Accéder au formulaire -></router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'IngenierieConseilPatrimoniaux',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data () {
    return {
      greenHeaderMessage: {
        titre: '',
        sousTitre: ''
      },
      temoignages: {},
      focus: [],
      bulles: []
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Ingénierie et conseils patrimoniaux')
      .then(res => {
        this.focus = res
        this.greenHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
        this.greenHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
        this.bulles = Object.keys(this.focus).filter((key) => {
          return key.substring(0, 5) === 'bulle'
        })
      })
  }
}
</script>
<style>
.paragraphe1 {
  background-image: url("../../assets/images/ingenierieEtConseilPatrimoniaux_p1_bg.png");
}
.bulle {
  flex: 1 1 0px
}
.bulleGrid {
  max-width: 740px;
}
</style>
